<template>
  <li
    v-if="branchName"
    class="nav-item branch-context"
  >
    <div class="branch-context__icon">
      <feather-icon
        icon="MapPinIcon"
        size="15"
      />
    </div>
    <div class="branch-context__copy">
      <span class="branch-context__label">Branch</span>
      <strong>{{ branchName }}</strong>
    </div>
  </li>
</template>

<script>
export default {
  data() {
    return {
      branchName: '',
    }
  },
  mounted() {
    const userData = this.$cookies.get('userData') || {}
    const userBranch = userData.branch
    this.branchName = userBranch !== null && userBranch ? userBranch.branch_name : ''
  },
}
</script>

<style lang="scss" scoped>
.branch-context {
  display: flex;
  align-items: center;
  max-width: 240px;
  min-height: 40px;
  margin-right: 0.75rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid rgba(34, 41, 47, 0.08);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 4px 14px rgba(34, 41, 47, 0.04);

  .branch-context__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    margin-right: 0.5rem;
    border-radius: 8px;
    color: #00a76f;
    background: rgba(0, 167, 111, 0.1);
    flex: 0 0 auto;
  }

  .branch-context__copy {
    min-width: 0;
    line-height: 1.1;
  }

  .branch-context__label {
    display: block;
    color: #6e6b7b;
    font-size: 0.68rem;
    text-transform: uppercase;
  }

  strong {
    display: block;
    overflow: hidden;
    max-width: 170px;
    color: #2f3542;
    font-size: 0.86rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

@media (max-width: 991.98px) {
  .branch-context {
    display: none;
  }
}
</style>
